var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.066 2.934A5.75 5.75 0 0 1 17.75 7v3.25H19A2.75 2.75 0 0 1 21.75 13v7A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-7A2.75 2.75 0 0 1 5 10.25h1.25V7a5.75 5.75 0 0 1 9.816-4.066m-7.071 1.06A4.25 4.25 0 0 1 16.25 7v3.25h-8.5V7a4.25 4.25 0 0 1 1.245-3.005M3.75 13c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgLock;